
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punedarshancabbooking() {



    const cardData =
    {
        keyword: 'Pune Darshan Cab Booking',
        heading: 'Platinum24 Cabs: Pune Darshan Cab Booking',
        headingDescription: ' Platinum24 Cabs offers hassle-free Pune Darshan Cab Booking, making it easy to explore the city’s famous temples, heritage landmarks, and tourist attractions in comfort. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures safe, air-conditioned travel with ample space for families and groups. With experienced chauffeurs who know Pune’s cultural and spiritual routes, we provide guided travel to places like Shaniwar Wada, Dagdusheth Halwai Ganpati, Parvati Hill, Aga Khan Palace, and Saras Baug. Platinum24 Cabs delivers affordable fares, flexible packages, and reliable service, ensuring your Pune Darshan is smooth, spiritual, and memorable.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, its majestic gates, fountains, and sprawling gardens narrate stories of valor and legacy. Though partially destroyed by fire in 1828, its ruins still captivate tourists. The evening light-and-sound show brings alive Bajirao and Mastani’s era. A must-visit for history lovers, it is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now houses a museum showcasing Gandhi’s personal belongings and rare photographs. Its Italian arches, sprawling lawns, and tranquil vibe make it a top tourist attraction. It is Pune’s historic gem of inspiration and peace."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Perched on a hill, it offers trekking trails and panoramic Sahyadri views. Visitors explore bastions, memorials, and temples that echo Maratha bravery. Monsoon enhances its beauty with misty clouds and waterfalls. Locals serve rustic pithla-bhakri at the fort. Sinhagad is Pune’s perfect mix of adventure, history, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The grand idol is adorned with gold and jewels, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of festivities. It is also known for charitable and cultural activities. The spiritual energy here is unmatched. Dagdusheth Temple is Pune’s divine cultural and spiritual heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. Its rock-cut sanctum, stone pillars, and Nandi mandapa reflect ancient Indian craftsmanship. Despite being in the heart of the city, it offers peace and a spiritual retreat. Evening aartis create a mystical aura. History lovers admire its timeless carvings. Pataleshwar is Pune’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and antiques from daily life. Its highlight is the recreated Mastani Mahal. Students and history lovers find it highly educational and engaging. The museum preserves traditions from across India’s regions. It is Pune’s cultural treasure chest of art and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The Parvati Temple atop the hill is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, blending devotion with adventure. The site also houses a small museum and shrines. Sunsets and sunrises from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across lush gardens, it offers meditation, yoga, and self-discovery programs. Japanese Zen gardens, swimming pools, and meditation halls enhance the experience. It attracts seekers from across the world. Visitors leave with peace and rejuvenation. Osho Ashram is Pune’s international center of mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and beautifully manicured lawns. Families enjoy walks, photography, and picnics here. Seasonal flowers and greenery make it picturesque year-round. It symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of peace and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam on the Mutha River is a popular weekend retreat near Pune. It supplies water to the city while offering scenic landscapes of hills and waters. In monsoon, the dam overflows spectacularly, drawing crowds. Vendors serve hot corn and tea, adding to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural escape."
  }
],



       "services": [
    {
      "name": "Pune Darshan Cab Service",
      "description": "Discover Pune's cultural richness and historical significance with our Pune Darshan Cab Service. This comprehensive sightseeing package includes visits to prominent locations like Shaniwar Wada, Aga Khan Palace, Saras Baug, and more. Whether you're a tourist or a local planning a weekend outing, our cabs offer comfortable AC vehicles, knowledgeable drivers, and flexible itineraries to suit your interests. From spiritual temples to colonial landmarks, explore the best of Pune in a single day with ease, safety, and convenience."
    },
    {
      "name": "Pune Darshan Taxi Booking",
      "description": "Book your Pune Darshan Taxi effortlessly through our website or mobile app. With instant confirmations, real-time tracking, and multiple cab options ranging from sedans to SUVs, the booking experience is fast and user-friendly. Our services include door-to-door pickup and drop, experienced drivers, and well-maintained vehicles to ensure a smooth sightseeing experience. Ideal for families, solo travelers, and tourists looking for a structured city tour."
    },
    {
      "name": "Pune Darshan Tour Cabs",
      "description": "Our Pune Darshan Tour Cabs are curated for complete city tours covering historical forts, religious sites, gardens, and cultural landmarks. Choose between full-day or half-day packages with guided assistance, custom route options, and AC-enabled vehicles. Our professional drivers help you explore the city comfortably while sharing local insights, making the journey informative and enjoyable."
    },
    {
      "name": "Pune City Darshan Taxi",
      "description": "Explore Pune's urban charm and heritage with our Pune City Darshan Taxi service. The service is ideal for tourists who want a thorough city experience in one day. From heritage structures like Lal Mahal to peaceful spots like Osho Garden, our cabs are equipped for comfort, and our drivers are familiar with the city’s hidden gems and top-rated attractions. A great choice for weekend getaways or holiday exploration."
    },
    {
      "name": "Affordable Pune Darshan Cab",
      "description": "Enjoy a full Pune sightseeing experience without breaking the bank with our Affordable Pune Darshan Cab. We provide budget-friendly packages that include major sightseeing points, fuel, tolls, and parking costs. Ideal for students, small families, or solo travelers looking to explore the city's highlights in a cost-effective yet comfortable manner."
    },
    {
      "name": "Pune Darshan Taxi with Driver",
      "description": "Hire a dedicated Pune Darshan Taxi with Driver who knows the city inside out. All our drivers are experienced, verified, and trained to offer a pleasant travel experience. With deep knowledge of tourist routes, traffic patterns, and the best times to visit each location, our driver ensures a smooth and enjoyable tour tailored to your needs."
    },
    {
      "name": "Pune Darshan Cab Packages",
      "description": "Choose from our diverse Pune Darshan Cab Packages that offer flexibility, affordability, and a wide choice of vehicles. Packages range from 4-hour express tours to full-day city explorations, covering everything from spiritual journeys to historical site visits. You can customize your itinerary or pick from our pre-designed city tour plans curated by local travel experts."
    },
    {
      "name": "Pune Local Darshan Taxi",
      "description": "Perfect for residents and returning visitors, the Pune Local Darshan Taxi service helps you revisit the city's cultural and spiritual landmarks in a relaxed manner. Choose by-the-hour service or a fixed package and enjoy places like Dagdusheth Temple, Parvati Hill, Kelkar Museum, and more with personalized attention and smooth navigation."
    },
    {
      "name": "Pune Darshan Car Rental",
      "description": "Opt for Pune Darshan Car Rental and get a wide range of vehicles—from hatchbacks to luxury sedans—for a full-day city tour. Ideal for those preferring privacy and flexibility, you can rent a car with or without a chauffeur. All vehicles are sanitized, air-conditioned, and serviced regularly to ensure safety and comfort."
    },
    {
      "name": "Pune Darshan One Day Cab",
      "description": "Looking to explore all major tourist spots in just one day? Our Pune Darshan One Day Cab is crafted for travelers with limited time. The route covers top landmarks with timely pickups, minimal wait times, and the convenience of customized stops. Great for weekend trips, family outings, and short stays in the city."
    },
    {
      "name": "Pune Darshan Taxi Rates",
      "description": "We offer transparent and affordable Pune Darshan Taxi Rates with no hidden charges. Our pricing covers fuel, parking, and tolls within city limits, and is based on duration or fixed itineraries. Whether you're looking for economy or premium vehicles, our competitive rates provide excellent value for money."
    },
    {
      "name": "Pune Darshan Cab Online Booking",
      "description": "Use our Pune Darshan Cab Online Booking system for easy reservations at any time. Just select your preferred package, vehicle type, and pickup time, and you're ready to go. Our online platform supports multiple payment methods, live driver tracking, and instant customer support for a seamless booking experience."
    },
    {
      "name": "Pune Sightseeing Darshan Cab",
      "description": "Our Pune Sightseeing Darshan Cab combines guided sightseeing with relaxed travel. With this service, you’ll visit must-see attractions like Raja Dinkar Kelkar Museum, Katraj Zoo, Sinhagad Fort, and more. Perfect for tourists who want both a structured tour and time for personal exploration."
    },
    {
      "name": "Pune Darshan Taxi Deals",
      "description": "Check out our special Pune Darshan Taxi Deals that include discounts on group bookings, festival tours, and combo packages. Whether you're booking during the weekend or festive season, our promotional offers make city touring even more affordable. Sign up for alerts and coupons to save more on every ride."
    },
    {
      "name": "Pune Darshan Taxi Service 24x7",
      "description": "Need a city tour on a tight schedule? Our Pune Darshan Taxi Service 24x7 operates day and night to accommodate early morning pilgrims, late-night travelers, or emergency sightseeing requests. Enjoy full-time support, flexible timing, and reliable service with professional drivers ready to assist you around the clock."
    }
  ],
  "tableData": [
    ["Pune Darshan Cab Service", "Pune Darshan Taxi Booking"],
    ["Pune Darshan Tour Cabs", "Pune City Darshan Taxi"],
    ["Affordable Pune Darshan Cab", "Pune Darshan Taxi with Driver"],
    ["Pune Darshan Cab Packages", "Pune Local Darshan Taxi"],
    ["Pune Darshan Car Rental", "Pune Darshan One Day Cab"],
    ["Pune Darshan Taxi Rates", "Pune Darshan Cab Online Booking"],
    ["Pune Sightseeing Darshan Cab", "Pune Darshan Taxi Deals"],
    ["Pune Darshan Taxi Service 24x7", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Convenient Pune Darshan Cab Booking",
      "WhyChoosedescription": "Platinum24 Cabs offers easy and hassle-free cab booking for Pune Darshan tours covering all major attractions."
    },
    {
      "WhyChooseheading": "Experienced Drivers Knowledgeable About Pune Darshan Routes",
      "WhyChoosedescription": "Our drivers are well-versed with popular Pune sightseeing spots ensuring a smooth and informative journey."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs for a comfortable and safe Pune Darshan experience."
    },
    {
      "WhyChooseheading": "Flexible Packages for Half-Day, Full-Day, and Customized Tours",
      "WhyChoosedescription": "Choose from various packages tailored to suit your schedule and sightseeing preferences."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Get upfront pricing inclusive of fuel, tolls, and driver allowances for worry-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
      "WhyChoosedescription": "Our dedicated support team is available anytime to help you with bookings and queries."
    },
    {
      "WhyChooseheading": "Ideal for Families, Tourists, and Corporate Groups",
      "WhyChoosedescription": "Perfect for all kinds of travelers looking to explore Pune comfortably."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers based on your travel needs."
    }
  ]






























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune Darshan cab booking services?',
        answer: 'Yes, Platinum24 Cabs offers convenient and reliable Pune Darshan cab booking services to explore popular temples and tourist spots in and around Pune.',
    },
    {
        question: 'How can I book a Pune Darshan cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune Darshan cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What places are covered in the Pune Darshan cab tours?',
        answer: 'Our Pune Darshan tours typically include visits to famous temples like Dagdusheth Ganpati, Parvati Temple, Chaturshringi Temple, and other key cultural and historical sites.',
    },
    {
        question: 'Can I customize the Pune Darshan itinerary?',
        answer: 'Yes, we offer customizable Pune Darshan cab packages tailored to your preferences and schedule.',
    },
    {
        question: 'What types of vehicles are available for Pune Darshan cab bookings?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to accommodate individuals and groups.',
    },
    {
        question: 'Are the drivers experienced with Pune Darshan routes?',
        answer: 'Yes, our drivers are well-versed with Pune’s key religious and tourist locations to ensure a smooth and informative journey.',
    },
    {
        question: 'Can I book a Pune Darshan cab for half-day or full-day trips?',
        answer: 'Yes, we provide both half-day and full-day Pune Darshan cab packages based on your needs.',
    },
    {
        question: 'Are safety and hygiene protocols followed during Pune Darshan rides?',
        answer: 'Absolutely. All vehicles are sanitized regularly, and drivers follow strict safety measures for your protection.',
    },
    {
        question: 'Is round-trip Pune Darshan cab service available?',
        answer: 'Yes, round-trip and hourly rental options are available for Pune Darshan tours.',
    },
    {
        question: 'Do you offer corporate Pune Darshan cab bookings?',
        answer: 'Yes, customized corporate packages for Pune Darshan tours can be arranged on request.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohan Patil',
        feedback: 'Pune Darshan cab booking with Platinum24 Cabs was very convenient. The driver was knowledgeable and the vehicle was comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Joshi',
        feedback: 'Had a wonderful Pune Darshan experience thanks to Platinum24 Cabs. The booking was smooth and the service excellent.',
        rating: 5,
    },
];






















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneDarshanCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable Pune Darshan cab service offering city darshan tours, one day packages, local darshan taxi, and 24x7 taxi booking with experienced drivers.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "Pune Darshan Cab Service",
    "Pune Darshan Taxi Booking",
    "Pune Darshan Tour Cabs",
    "Pune City Darshan Taxi",
    "Affordable Pune Darshan Cab",
    "Pune Darshan Taxi with Driver",
    "Pune Darshan Cab Packages",
    "Pune Local Darshan Taxi",
    "Pune Darshan Car Rental",
    "Pune Darshan One Day Cab",
    "Pune Darshan Taxi Rates",
    "Pune Darshan Cab Online Booking",
    "Pune Sightseeing Darshan Cab",
    "Pune Darshan Taxi Deals",
    "Pune Darshan Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};








    return (
        <div>
<Helmet>
  <title>Pune Darshan Cab Booking | Affordable Pune City Darshan Taxi Service</title>
  <meta
    name="description"
    content="Affordable and reliable Pune Darshan cab service offering city darshan tours, one day packages, local darshan taxi, and 24x7 taxi booking with experienced drivers."
  />
  <meta
    name="keywords"
    content="Pune Darshan Cab Service, Pune Darshan Taxi Booking, Pune Darshan Tour Cabs, Pune City Darshan Taxi, Affordable Pune Darshan Cab, Pune Darshan Taxi with Driver, Pune Darshan Cab Packages, Pune Local Darshan Taxi, Pune Darshan Car Rental, Pune Darshan One Day Cab, Pune Darshan Taxi Rates, Pune Darshan Cab Online Booking, Pune Sightseeing Darshan Cab, Pune Darshan Taxi Deals, Pune Darshan Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneDarshanCabSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/60.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punedarshancabbooking;